import React, {useState} from 'react'
import RegionItem from '../../components/UI/RegionItem'
import TopPlayedChart from '../../components/UI/TopPlayedChart'
import {connect} from 'react-redux'
import Loader from "../../components/UI/Loader"
import * as actions from '../../redux/actions/index'
import DropdownFilter from '../../utils/dropdown.class'
import Error from "../../components/UI/Error"
import { regionToDeviceObject } from '../../utils/utility'
import { useHistory } from 'react-router-dom'
import {sum_devices} from '../../utils/utility'
import {Modal} from "@material-ui/core";
import TopPlayedGames from "../../components/UI/TopPlayedGames";
import GameRanking from '../../components/UI/GameRanking'
const fs = require('fs')

const Region = ({loading, getData, error, devices, dateRange, setAccountChart, accountChart, setActiveRegion, skip, gamesSorting, setGamesSorting}) => {
    let graphData = Object.keys(devices).sort().map((region) => regionToDeviceObject(region, devices[region]))
    const history = useHistory();
    
    const regions = Object.keys(devices);
    if(regions.length === 1 && regions[0] !== '0' && skip)
    {
        const region = regions[0];
        setActiveRegion(region);
        history.replace({
            ...history.location,
            pathname: `/${region}`,
        });
    }
    
    let _device = {...graphData[0]}
    sum_devices(_device, graphData)
    const {gamesTop} = _device
    
    //MODAL HANDLER
    const [modalOpen, setModalOpen] = useState(false);
    const handleModalOpen = () => {
        setModalOpen(true);
    };

    const handleModalClose = () => {
        gamesTop.forEach(game => game.show = true)
        setModalOpen(false);
    };
    //MODAL HANDLER END

    // CHART
    const accountChartDropdown = new DropdownFilter({
        // filterNames: ['Top played devices', 'Top OMI score', 'Increased OMI'],
        filterNames: ['Top played devices', 'Top OMI score'],
        option: accountChart,
        setOption: setAccountChart,
        sourceArray: graphData
    })
    // CHART END

    const deviceWrapper = () => {
        return Object.keys(devices).sort().map((region, i) => {
            return (
                <RegionItem key={region + i} region={region} timePlayed={graphData[i].timePlayed}/>
            )
        }).sort((item1, item2) => item2.props.timePlayed - item1.props.timePlayed)
    }


    if (loading) {
        return <Loader/>
    }
    if (error) {
        return <Error/>
    }

    //GAMES DROPDOWN
    const gamesSortDropdown = new DropdownFilter({
        // filterNames: ['Top OMI score', 'Most played games', 'Increased OMI games'],
        filterNames: ['Top OMI score', 'Most played games'],
        option: gamesSorting,
        setOption: setGamesSorting,
        sourceArray: gamesTop
    }) 
    //GAMES DROPDOWN END

    return (
        <div className='flex'>
            <div className='mainWrapper'>
                <TopPlayedChart chartTypeButton={accountChartDropdown.render()}
                    chartData={accountChartDropdown.chartData()}/>
                <TopPlayedGames gamesTop={gamesSortDropdown.sortedArray()} dropdown={gamesSortDropdown.render()}
                    openDialog={handleModalOpen}/>
            </div>
            <div className='sideBarWrapper'>
            <div className='devicesWrapper'>
                    {deviceWrapper()}
                </div>
            </div>
            <Modal
                open={modalOpen}
                onClose={handleModalClose}
            >
                <div className='modalWrapper flex'>
                    <GameRanking gamesArr={gamesSortDropdown.sortedArray()} dropdown={gamesSortDropdown.render()}
                                 dateRange={dateRange}/>
                </div>
            </Modal> 
        </div>
    )
}

const mapStateToProps = (state) => ({
    loading: state.analytics.loading,
    getData: state.analytics.getData,
    error: state.analytics.error,
    devices: state.analytics.devices,
    dateRange: state.analytics.dateRange,
    accountChart: state.analytics.accountChart,
    skip: state.analytics.skip,
    gamesSorting: state.analytics.gamesSorting,

})

export default connect(mapStateToProps, actions)(Region)